export default "__VITE_ASSET__BDvKsKz9__"